import * as React from 'react';
import { List, withStyles, StyledComponentProps } from '@material-ui/core';
import { contact } from '../../../../model/contact';
import ContactItem from './ContactItem';
import { styles } from './styles';
import { room } from '../../../../model/room';


interface IProps extends StyledComponentProps {
    contactList: Array<contact>;
    onContactClick: (sub: string) => void;
    navigateTo: (path: string) => void;
    selected: string;
    roomList: Array<room>;
}


const ContactList = (props: IProps) => {
    var names = props.roomList.map(function (item) {
        return item['_id'];
    });
    // console.log("XXXXXXXXXXXXXXXXXX:", props.roomList, names);
    return (
        <List className={props.classes.root}>
            {props.contactList && props.contactList.map((c, i) =>
                <div key={`1${i}`}>
                    <ContactItem
                        roomList={names}
                        isSelected={props.selected === c.sub}
                        contact={c}
                        onContactClick={props.onContactClick}
                        navigateTo={props.navigateTo}
                    />
                </div>
            )}
        </List>
    );
}
export default withStyles(styles)(ContactList)